module.exports = __webpack_public_path__ + "static/media/panzoom.e912bae3.mp4";